// "AI runs just changed in this browser": the one-line signal from the AI Optimise tab (and from the admin header's
// Continue) to whoever shows AI state, so the header polls the spend at once instead of at its next 10-minute tick and a
// mounted AI panel reloads its list. Import-free CommonJS, so it can be tested in plain node -- see
// src/lib/ai-optimization.js.
//
// Why a module-level set: the AI panel (on the strategies page) and the header (in the persistent layout) share this one
// instance, so no provider or context is needed. Who owns a subscription: createSpendPoll (src/lib/spend-poll.js)
// subscribes in start() and unsubscribes in stop(), so the set is bounded by the mounted headers (one); every mounted AI
// panel subscribes in an effect and unsubscribes in its cleanup (a continueListener). Who notifies, and with which kind:
// the Start button after trading-api accepted the run ('start', the default), a Continue from the panel or the header after
// trading-api answered ('continue') and a successful Cancel ('cancel'). The header ignores the kind and polls at once; the
// AI panel reloads on 'continue' only (Start and Cancel reload it themselves). Nothing here talks to the server or owns a
// timer; a notification only asks listeners to refresh, it never starts anything.
const listeners = new Set();

// Adds a listener and returns the function that removes it (harmless to call twice)
const subscribeAiActivity = listener => {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
};

// Calls every listener once with the kind of the change. A copy is iterated, so a listener subscribed during the round
// waits for the next one, and a listener that throws is reported without stopping the others (or the flow that notified)
const notifyAiActivity = (kind = 'start') => {
	Array.from(listeners).forEach(listener => {
		try {
			listener(kind);
		} catch (error) {
			console.error(error);
		}
	});
};

// How many listeners are subscribed (for the leak test)
const aiActivityListenerCount = () => listeners.size;

module.exports = { subscribeAiActivity, notifyAiActivity, aiActivityListenerCount };
